import { CardElement } from '@stripe/react-stripe-js';
import { Post } from '../../api/server';
import { requiresPayment, validateCustomerInfo } from './util';

export async function handleCheckoutPay({
  customerInfo,
  cart,
  currentTicket,
  company,
  stripe,
  elements,
  getTotal,
  onValidationError,
  onPaymentError,
  onPaymentStart,
  onPaymentEnd,
  onSuccess,
  onFailure,
  affId,
}) {
  const validation = validateCustomerInfo(customerInfo);
  if (!validation.isValid) {
    onValidationError(validation.errors);
    return;
  }

  const total = getTotal();
  const hasCost = requiresPayment(total);
  if (hasCost && (!stripe || !elements)) {
    onPaymentError('Payment is still loading. Please try again in a moment.');
    return;
  }

  onPaymentStart();
  onPaymentError('');
  try {
    let paymentMethod = null;
    if (hasCost) {
      const cardElement = elements.getElement(CardElement);
      if (!cardElement) {
        onPaymentError('Card input is not ready yet. Please try again.');
        return;
      }
      const result = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
        billing_details: {
          name: `${validation.values.firstName} ${validation.values.lastName}`,
          email: validation.values.email,
          phone: validation.values.phone,
        },
      });
      if (result.error) {
        onPaymentError(result.error.message || 'Could not process your card.');
        return;
      }
      paymentMethod = result.paymentMethod;
    }

    const response = await Post(`/events/v2/buyTickets/${currentTicket._id}`, {
      token: paymentMethod,
      company: currentTicket?.company?._id || company?._id,
      first_name: validation.values.firstName,
      last_name: validation.values.lastName,
      email: validation.values.email,
      phone: validation.values.phone,
      tickets: cart,
      amountDue: Number(total).toFixed(2),
      affId: affId || null,
    });

    if (response?.paymentIntent?.status === 'requires_action') {
      onPaymentError('Your bank requires additional authentication, which is not available for this checkout yet. Please use another card or try again.');
      return;
    }

    onSuccess(response);
  } catch (error) {
    onFailure(error);
  } finally {
    onPaymentEnd();
  }
}
